import React, { useState } from "react";
import {  NavLink } from "react-router-dom";
export default function CollectionSubMenu(props) {
    const [page]  =  useState(props.data);
    // console.log('sbmenu', page);
    return (
        <>
         <ul>
            <li><NavLink className="menuSubN" activeclassname="active"  to={ (page === 'collection' ? '../collection/created' : page === 'nft' ? '../nft/created':'')}>Created</NavLink></li>
            <li><NavLink className="menuSubN" to={'../nft/upcomingnft'} state={{ page: page }}>Upcoming Artworks </NavLink></li>
            <li><NavLink className="menuSubN" activeclassname="active"  to={ (page === 'collection' ? '../collection/soldbyartist': '../nft/soldbyartist')} state={{ page: page }}>Sold By Artist</NavLink></li>
            <li><NavLink className="menuSubN" to={'../nft/collected'} state={{ page: page }}>Collected</NavLink></li>
            {/* <li><NavLink className="menuSubN" to={'/'}>Activity</NavLink></li>
            <li><NavLink className="menuSubN" to={'/'}>Liked</NavLink></li> */}
             </ul>
        </>
    )
}